import React, { useState } from 'react'
import "./Payments.scss"
import { FaCheck } from "react-icons/fa";
import { FaRegCopy } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { PiUpload } from 'react-icons/pi';

export default function Payments() {
      const [activeRow, setActiveRow] = useState(null);
      const [open, setOpen] = useState(null);
        const toggleDetails = (index) => {
    setActiveRow(activeRow === index ? null : index);
  };
      const [orders] = useState([
        {
          id: '#301555',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
        {
          id: '#301556',
          client: 'Osama alabyaare',
          product: 'E-book',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
        {
          id: '#301555',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: '#301555',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: '#301555',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: '#301555',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: '#301555',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: '#301555',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
      ]);
  return (
    <div className='p-3'>
             <div className="headerr">
        <div className="stock-filters">
                <Link to="/dashboard/Informations"  className='no-style-link '>    <button className="stock-filter ">Information</button></Link>          <Link to="/dashboard/Client-Orders"  className='no-style-link'> <button className="stock-filter">Orders</button></Link>
                  <Link to="/dashboard/Client-Payments"  className='no-style-link'> <button className="stock-filter actives">Payments</button></Link>
                           <Link to="/dashboard/Client-Notices"  className='no-style-link'> <button className="stock-filter">Notices</button></Link>
                                    <Link to="/dashboard/Emarketing-products"  className='no-style-link'> <button className="stock-filter">E-marketing</button></Link>

        </div>
      
        <div className="search-wrapperr">
          <input
            type="text"
            placeholder="Search by order id"
            className="stock-search"
          />
          <i className="fa-solid fa-magnifying-glass search-icon"></i>
        </div>
      
        <div className="stock-header">
          <input type="date" placeholder="select dates" />
          <div className="stock-actions">
            <button className="stock-btn blue">Filters</button>
            <button className="stock-btn"><PiUpload/>  Export</button>
          </div>
        </div>
      </div>
        <div className='personal-info mb-3'>
        <div className=' d-flex align-items-center gap-5 '>
            <div className=' '>
<div className='image mb-4'>
    Image
</div>
<div className=' d-flex align-items-center gap-2'>
 <div style={{
                            backgroundColor:"#0ec755",
                            width:"10px",
                            height:"10px",
                            borderRadius:"50px",
                            color:"#b6bfe8"

                        }}></div>
                        <span style={{
                            color:"#b6bfe8"
                        }}>Online</span>
</div>
            </div>

<div className=' d-flex flex-column'>
<h4 style={{
    color:"black",
    marginBottom:"15px",
    fontSizeP:"20px"
}} >Osama Ali Ali</h4>
<span style={{
    color:"#858993",
    fontSize:"15px",
    marginLeft:"15px"
}}>         Osama@gmail.com</span>
<span style={
    {
          marginLeft:"15px"
    }
}>Client +</span>
</div>


        </div>

        <div className='vrt-line'></div>

<div className="personal-info-box">
  <p className="section-title">Personal Information</p>
  <div className="info-list">
    <div className="info-item">
      <span className="label">Contact Number</span>
      <span className="value">003737737</span>
    </div>
    <div className="info-item">
      <span className="label">Gender</span>
      <span className="value">Male</span>
    </div>
    <div className="info-item">
      <span className="label">Date of Birth</span>
      <span className="value">1 Jan, 1985</span>
    </div>
    <div className="info-item">
      <span className="label">Country</span>
      <span className="value">Morocco</span>
    </div>
    <div className="info-item">
      <span className="label">Member Since</span>
      <span className="value">3 March, 2023</span>
    </div>
  </div>
</div>
        <div className='vrt-line'></div>

<div className="personal-info-box d-flex  flex-column justify-content-around">
    <div>
  <p className="section-title">Performance information</p>
<div>
<span  style={{
    color:"#1d4ed8",
    fontWeight:'bold',
     fontSize:"10px"
}}>Wallt</span>   <span style={{
    color:"#1d4ed8",
    fontWeight:'bold',
    fontSize:"18px"
}}>EGP35.00</span>
</div>

    </div>


<div className=' d-flex gap-5'>
    <div className=' d-flex  flex-column'>
        <span style={{
            color:"#01a9fc", 
             fontWeight:'bold'
        }}>150</span>
        <span style={{
            color:"#7f838c", 
            
        }}>Total Orders</span>
    </div>
       <div className=' d-flex  flex-column'>
        <span style={{
            color:"#28c76f", 
             fontWeight:'bold'
        }}>50</span>
        <span style={{
            color:"#7f838c", 
        
        }}>Balance</span>
    </div>
       <div className=' d-flex  flex-column'>
        <span style={{
            color:"#e71d36", 
             fontWeight:'bold'
        }}>350</span>
        <span style={{
            color:"#7f838c", 
             
        }}>Total Points</span>
    </div>
</div>
</div>

      </div>


          <div className="orders-table-wrapper">
              <table className="orders-table">
                <thead>
                  <tr>
                    <th><input type="checkbox" /></th>
                    <th>Order ID</th>
                    <th>Client Name</th>
                    <th>Product</th>
                    <th>Date</th>
                    <th>Order time</th>
                    <th>Amount</th>
                       <th className="product-header col" onClick={() => setOpen(open === "Status" ? null : "Status")}>
                        Status
                        <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {open === "Status" && (
                          <div className="list-body">
                            <ul className="list">
                              <li>All Status</li>
                              <li>New</li>
                              <li>On Process</li>
                              <li>Late Order</li>
                            </ul>
                          </div>
                        )}
                      </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td><input type="checkbox" /></td>
                    
                        <td className="order-id" style={{
                        color:"#62aec4",
                        fontWeight:"bold",
                        marginRight:"10px"
            
                    }}>{order.id} <FaRegCopy style={{
                        color:"#8b8d97",
                        fontSize:"14px"
                    }}/></td>
                        <td>{order.client}</td>
                        <td>{order.product}</td>
                        <td>{order.date}</td>
                        <td>{order.time}</td>
                        <td>{order.amount}</td>
                        <td>
                          <span className="status new">{order.status}</span>
                        </td>
                        <td>
                          <span
                            className="order-details"
                            onClick={() => toggleDetails(index)}
                          >
                            ...
                          </span>
                        </td>
                      </tr>
      
                   {activeRow === index && (
       <>
      
          <tr className="details-row headers-row">
            <td colSpan="9">
              <div className="order-details-box header">
                <div className="section "
                 style={{
                  color:"#999999"
                }}>Full Name</div>
                <div className="section"   style={{
                  color:"#999999"
                }}>PHONE</div>
      
      
                <div className="section"   style={{
                  color:"#999999"
                }}>EMAIL
                </div>
                <div className="section"   style={{
                  color:"#999999"
                }}>COUNTRY</div>
      
                <div className="section"   style={{
                  color:"#999999"
                }}>DATE</div>
      
                <div className="section"   style={{
                  color:"#999999"
                }}>Time</div>
      
                <div className="section"  style={{
                  color:"#999999"
                }}>Print</div>
              </div>
            </td>
          </tr>
      
          
          <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values">
                <h3 className="section">Osama Ali alabyaare</h3>
                <h3 className="section">+20 1012345678</h3>
                <h3 className="section">osama@email.com</h3>
                <h3 className="section">Egypt</h3>
                <h3 className="section">12/12/23</h3>
                <h3 className="section">12:00 PM</h3>
                <div   className="product-header"
       onClick={() => setOpen(open === "Confirm" ? null : "Confirm")}>
      
        Confirm
        <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
           {open === "Confirm" && (
                              <div className="list-body">
                                <ul className="list">
                                  <li>All Products</li>
                                  <li>Social media</li>
                                  <li>E-marketing</li>
                                </ul>
                              </div>
                            )}
      
      
                </div>
              </div>
            </td>
          </tr>
        <>
      
      
      {/* ////////////////////// */}
          <tr className="details-row headers-row">
            <td colSpan="9">
              <div className="order-details-box header">
                <div className="section"    style={{
                  color:"#999999"
                }}>ORDER TYPE</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>CATEGORY</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>SKU</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>DURATION</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>START</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>ENDS</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>DAYS</div>
            
              </div>
            </td>
          </tr>
      
          
          <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values">
                <h3 className="section">Service</h3>
                <h3 className="section">Social media</h3>
                <h3 className="section">#6580</h3>
                <h3 className="section">1 month</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">30</h3>
       
              </div>
            </td>
          </tr>
      {/* //////////////////////////////////// */}
      
        <>
      
          <tr className="details-row headers-row">
            <td colSpan="9">
              <div className="order-details-box header">
                <div className="section"    style={{
                  color:"#999999"
                }}>PRICE</div>
                <div className="section"   style={{
                  color:"#999999"
                }}>TOTAL AMOUNT</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>PAYMENT METHOD</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>BANK NAME</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>ACCOUNT NO</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>DUE DATE</div>
                <div className="section"    style={{
                  color:"#999999"
                }}>PAYMENT STATUS</div>
              </div>
            </td>
          </tr>
      
          
          <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values">
                <h3 className="section">EGP200</h3>
                <h3 className="section">EGP200</h3>
                <h3 className="section">credit card</h3>
                <h3 className="section">+insta</h3>
                <h3 className="section">********65</h3>
                <h3 className="section">24 may 2025</h3>
      <div className="succ">
        <span className="icon-circle">
          <FaCheck className="icon" />
        </span>
        Successful
      </div>
      
      
              </div>
            </td>
          </tr>
      
          
        </>
          
        </>
          
        </>
        
      )}
      
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
    </div>
  )
}
